// Lead Generation Pop-up
/*
Logic:
Check if user previously has closed the popup or has subscribed before.
If user closed it >30 days ago, reset.
Pop-up will show after 200px scrolling or after 10 seconds of inactivity.

If user closed popup, it will not show again for 30 days.
If user successfully submitted the form, it will not show again.

Local storage stores 3 variables:
DoNotShowLeadGenAgain: when user closes popup
DoNotShowLeadGenAgainTime: log date when user closes
subscribedNewsletter: true if user submitted form or has signed up before
*/

global.LeadGenSlideUp = (function(custom_config) {

    var config = custom_config || {},
        thisObjectGAID = setDefault(config.id, "slideup1"), // custom ID for GA logging
        popupType = setDefault(config.popupType, "slideup"), // slideup or modal
        aggressive = setDefault(config.aggressive, false), // force to show everytime disregard localstorage and logged in
        checkNewsletter = setDefault(config.checkNewsletter, true), // Check if subscribed newsletter. (False if used for coupon code abandoned cart in future)
        daysToStore = setDefault(config.daysToStore, 30), // how many days to show pop-up again
        scrollThreshold = setDefault(config.scrollThreshold, 150), // how many pixels after scrolling
        showAfterSeconds = setDefault(config.showAfterSeconds, 3), // how many seconds of no activity
        newsletterSlug = setDefault(config.newsletterSlug, "updates"); // newsletter slug to subscribe to

    // event to show pop-up
    var showPopupEvent = new Event('showPopup');

    // set DOM object ID names to prevent conflict
    if (popupType == "slideup"){
        var thisObject = "#lead-generation";
    } else {
        var thisObject = "#lead-generation--modal";
    }

    function setDefault(_property, _default) {
      return typeof _property === 'undefined' ? _default : _property;
    }

    // visible state of popup
    var VisibleState = Object.freeze({
        CLOSED: 0,
        OPEN: 1
    });

    // default inital states
    var ElementState = {
        gaOpenSent: false,
        popup: VisibleState.CLOSED,
        success: 0,
        shouldWeShowPopup: false,
        subscribedNewsletter: false
    };

    // check for localstorage
    function localStorageAvailable() {
        if (typeof(Storage) !== "undefined") {
            return true;
        }
        else {
            return false;
        }
    }

    // set popup state by adding class
    function setPopupState(visibleState) {
        if (visibleState == VisibleState.OPEN){
            $(thisObject).addClass('open');
            if(popupType == "slideup"){
                $(thisObject).height($(thisObject+'-inner').height() + 40);
            }

            // send GA event once only
            if(!ElementState.gaOpenSent){
                if(window.gtag){
                    gtag('event', 'open', 
                    {   'event_category': 'leadgen',
                        'event_label': thisObjectGAID
                    });
                } else if (window.ga) {
                    ga('send', 'event', 'leadgen', 'open', thisObjectGAID);
                }
                ElementState.gaOpenSent = true;
            }

            // add to session storage so that we only show once per session (don't be irritating)
            if (localStorageAvailable()) {
                sessionStorage.setItem('LeadGenSlideupShown_'+thisObjectGAID, 'true');
            }
        }
        if (visibleState == VisibleState.CLOSED){
            $(thisObject).removeClass('open');
        }

        ElementState.popup = visibleState;
    }

    // logic if pop-up should show depending on localStorage
    function shouldWeShowPopup(){

        // let's see if local storage knows first
        // check if user has closed this before on localstorage
        if (localStorageAvailable()) {
            // if user has been shown once in this session, don't show
            if (sessionStorage.getItem('LeadGenSlideupShown_'+thisObjectGAID) === "true"){
                ElementState.shouldWeShowPopup = false;
                return;
            }
            // if user closed pop-up before, don't show
            else if (localStorage.getItem('DoNotShowLeadGenAgain_'+thisObjectGAID) && localStorage.getItem('DoNotShowLeadGenAgain_'+thisObjectGAID) === "true") {
                ElementState.shouldWeShowPopup = false;
                return;
            // if user signed up before don't show
            } else if (checkNewsletter && localStorage.getItem('subscribedNewsletter_'+thisObjectGAID) && localStorage.getItem('subscribedNewsletter_'+thisObjectGAID) === "true"){
                ElementState.subscribedNewsletter = true;
                ElementState.shouldWeShowPopup = false;
                return;
            // else from localstorage we know the user is not subscribed
            } else if (checkNewsletter && localStorage.getItem('subscribedNewsletter_'+thisObjectGAID) && localStorage.getItem('subscribedNewsletter_'+thisObjectGAID) == "false"){
                ElementState.subscribedNewsletter = false;
                ElementState.shouldWeShowPopup = true;
                window.dispatchEvent(showPopupEvent);
                return;
            } else {
                // seems like localStorage doesn't know. let's check if we are logged In.
                // check if Subscribed Newsletter
                if(loggedIn && checkNewsletter){
                    $.ajax({
                        url: "/newsletters/web-api/" + newsletterSlug + "/is-subscribed",
                        success: function(data){
                            // yes he's confirmed subscribed, don't show
                            if(data.is_subscribed){
                                saveNewsletterSubscribed();
                                ElementState.shouldWeShowPopup = false;
                                return;
                            // else, confirm show pop up
                            } else {
                                ElementState.subscribedNewsletter = false;
                                localStorage.setItem("subscribedNewsletter_" + thisObjectGAID, "false");
                                ElementState.shouldWeShowPopup = true;
                                window.dispatchEvent(showPopupEvent);
                                return;
                            }
                        }
                    });
                } else {
                    // else we show after all
                    ElementState.shouldWeShowPopup = true;
                    return;
                }
            }
        }

    }

    // show popup after scrolling 100px
    function showOnScroll(event) {
        var scrollTop = $(window).scrollTop;
        if (scrollTop > scrollThreshold) {
            setPopupState(VisibleState.OPEN);
        }
    }

    // hide popup
    function hideAfterClose(){
        setPopupState(VisibleState.CLOSED);
        window.removeEventListener('scroll',showOnScroll);

        // store state in localstorage and also the date
        if (localStorageAvailable()){
            localStorage.setItem('DoNotShowLeadGenAgain_'+thisObjectGAID, 'true');
            localStorage.setItem('DoNotShowLeadGenAgainTime_'+thisObjectGAID, +new Date);
        }

        // send GA event
        // send only when it is not success
        if (ElementState.success != 1){
            if(window.gtag){
                gtag('event', 'close', 
                {   'event_category': 'leadgen',
                    'event_label': thisObjectGAID
                });
            } else if (window.ga) {
                ga('send', 'event', 'leadgen', 'close', thisObjectGAID);
            }
        }
    }

    // show full form for mobile
    function showFullFormOnMobile(){
        $(thisObject).css('height','100vh');
        $(thisObject).css('bottom','0');
        $(thisObject).css('z-index','1000');
        $(thisObject+'__mobile').hide();
        $(thisObject+'__form-wrapper').show();
    }

    // show spinner when loading
    function showLoadingSpinner(){
        $(thisObject+' .lead-generation-button').html('Please Wait&nbsp;<img src="//d17c6mvbths9oc.cloudfront.net/images/cart-loading.gif" />');
        $(thisObject+' .lead-generation-button').prop('disabled', true);
        $(thisObject+'-form input').prop('disabled', true);
    }

    // show thank you message when success
    function showThankYou() {
        $(thisObject+'__form-wrapper').hide();
        $(thisObject+'__thank-you').show();

        // store success in localstorage
        saveNewsletterSubscribed();

        // send GA event
        if(window.gtag){
            gtag('event', 'success', 
            {   'event_category': 'leadgen',
                'event_label': thisObjectGAID
            });
        } else if (window.ga) {
            ga('send', 'event', 'leadgen', 'success', thisObjectGAID);
        }
    }

    // store newsletter subscribed state in localstorage
    function saveNewsletterSubscribed(){
        if (localStorageAvailable()){
            localStorage.setItem('subscribedNewsletter_'+thisObjectGAID, "true");
        }
        ElementState.subscribedNewsletter = true;
    }

    // show error message
    function showErrors(message) {

        var err = eval("(" + message + ")");

        // if already subscribed, show already message
        if(err.alreadySubscribed){
            $(thisObject+'__form-wrapper').hide();
            $(thisObject+'__already').show();
            // store success in localstorage
            saveNewsletterSubscribed();

            // send GA event
            if(window.gtag){
                gtag('event', 'alreadySubscribed', 
                {   'event_category': 'leadgen',
                    'event_label': thisObjectGAID
                });
            } else if (window.ga) {
                ga('send', 'event', 'leadgen', 'alreadySubscribed', thisObjectGAID);
            }

        // else show error message
        } else {
            //console.log(err.message);
            $(thisObject+' .lead-generation__errors').html("Some of your information is missing or incorrect. Please try again.");
            $(thisObject).height('600px');

            // re-enable input and submit buttons
            $(thisObject+' .lead-generation-button').html('Try Again');
            $(thisObject+' .lead-generation-button').prop('disabled', false);
            $(thisObject+'-form input').prop('disabled', false);

            // send GA event
            if(window.gtag){
                gtag('event', 'error', 
                {   'event_category': 'leadgen',
                    'event_label': thisObjectGAID
                });
            } else if (window.ga) {
                ga('send', 'event', 'leadgen', 'error', thisObjectGAID);
            }
        }
    }

    // ajax submit the form
    function submitForm(e){
        e.preventDefault();

        // show loading spinner
        showLoadingSpinner();

        var formData =  {
            "_token"    : $( 'input[name="_token"]' ).val(),
            "email"     : $( thisObject+' input[name=email]' ).val(),
            "firstname" : $( thisObject+' input[name=firstname]' ).val(),
            "lastname"  : $( thisObject+' input[name=lastname]' ).val()
        };

        $.ajax({
            type: 'POST',
            url: '/newsletters/web-api/' + newsletterSlug,
            data: formData,
            dataType: 'json',
            success: function(data){
                showThankYou();
                ElementState.success = 1;
            },
            error: function (data, status, error) {
                showErrors(data.responseText);
            }
        });

        //prevent the form from actually submitting in browser
        return false;
    }

    // reset local storage after 30 days
    // cal date difference
    Date.dateDiff = function(datepart, fromdate, todate) {
        datepart = datepart.toLowerCase();
        var diff = todate - fromdate;
        var divideBy = { w:604800000,
            d:86400000,
            h:3600000,
            n:60000,
            s:1000 };

            return Math.floor( diff/divideBy[datepart]);
    }

    // show popup again after 30 days
    function resetLocalStorage(){
        var previousDate;
        if(localStorage.getItem('DoNotShowLeadGenAgainTime_'+thisObjectGAID) != null){
            previousDate = new Date(parseInt(localStorage.getItem('DoNotShowLeadGenAgainTime_'+thisObjectGAID)));

            var daysSinceLastClosed = Date.dateDiff('d',previousDate.getTime(),new Date().getTime());

            if(daysSinceLastClosed > daysToStore)
            {
                localStorage.removeItem('DoNotShowLeadGenAgain_'+thisObjectGAID);
                localStorage.removeItem('DoNotShowLeadGenAgainTime_'+thisObjectGAID);
            }
        }
        // else do nothing
    }

    function setupTimings(){
        // wait for a few seconds then show on scroll
        setTimeout(function(){
            window.addEventListener('scroll', showOnScroll);
        }, 500);

        // if no scroll after 10 seconds, show it anyway
        setTimeout(function(){
            setPopupState(VisibleState.OPEN);
        }, showAfterSeconds*1000);
    }

    // do the necessary stuff on init
    function componentDidMount() {
        // reset local storage after 30 days, check if logged in first
        resetLocalStorage();
        // check if subscribed via AJAX and also local storage
        if(!aggressive){
            shouldWeShowPopup();
        } else {
            ElementState.shouldWeShowPopup = true;
        }
        window.addEventListener('showPopup',setupTimings);
    }

    function init() {
        //window.addEventListener('DOMContentLoaded', function() {
            componentDidMount();

            // submit form
            $(thisObject+'-form').on('submit', submitForm);

            // init for slideup type
            if(popupType == "slideup"){
                // show popup
                if(ElementState.shouldWeShowPopup){
                    window.dispatchEvent(showPopupEvent);
                }

                // close button
                $('.lead-generation-close-action').click(hideAfterClose);

                // mobile triggers
                $(thisObject+'-button-mobile').click(showFullFormOnMobile);
            }

            // init for modal types
            if(popupType == "modal"){
                if(ElementState.shouldWeShowPopup){

                    // ouibounce will handle everything
                    ouibounce($(thisObject)[0], {
                        cookieExpire: daysToStore,
                        aggressive: aggressive,
                        callback: function(){ $('#lead-generation').hide(); } // just in case there's a slide up, hide it
                    });

                    // use class as selector as there are a few close buttons
                    $('.lead-generation--modal-close-action').click(function(){
                        $(thisObject).hide();
                    });

                    // submit form
                    $(thisObject+'-form').on('submit', submitForm);
                }
            }
        //});
    }

    init();
});
